import ImageUploader from "./ImageUploader";

type FileImageUploaderType = { 
  container?: HTMLElement,
  fileinput?: HTMLElement, 
  onLoad?: (img: HTMLImageElement, file: File) => void, 
  onUpload?: (public_url: string) => void,
  onError?: () => void 
}

export default class FileImageUploader extends ImageUploader{

  onLoad = (img: HTMLImageElement, file: File) => {};
  onUpload = (public_url: string) => {};
  onError = () => {};

  constructor({ container, fileinput, onLoad, onUpload, onError }: FileImageUploaderType) {
    super();

    if (onLoad) {
      this.onLoad = onLoad;
    }
    if (onUpload) {
      this.onUpload = onUpload;
    }
    if (container) {
      this.attach(container);
    }
    if (fileinput) {
      this.bind(fileinput);
    }

    if(onError){
      this.onError = onError;
    }

    this.handleDrop = this.handleDrop.bind(this);
    this.handleOver = this.handleOver.bind(this);
  }

  attach(el: HTMLElement) {
    el.addEventListener('drop', this.handleDrop);
    el.addEventListener('dragover', this.handleOver);
  }

  bind(el: HTMLElement) {
    el.addEventListener('change', this.handleDrop);
  }

  destroy(el) {
    el.removeEventListener('change', this.handleDrop);
    el.removeEventListener('drop', this.handleDrop);
    el.removeEventListener('dragover', this.handleDrop);
  }

  handleDrop = (ev) => {
    ev.preventDefault();
    ev.stopPropagation();

    ([...(ev?.dataTransfer?.files ?? ev?.target?.files)] ?? [])
      .forEach(file => this.handleFile(file));
    ev.currentTarget.value = null;
  }

  private handleOver = (e) => {
    e.stopPropagation();
    e.preventDefault();
    if ([...e.dataTransfer?.items].every(item => item.kind === 'file' && FileImageUploader.allowedTypes.includes(item.type))) {
      e.dataTransfer.dropEffect = 'copy';
    } else {
      e.dataTransfer.dropEffect = 'none';
    }
  }

  private handleFile = (file) => {
    if (!FileImageUploader.allowedTypes.includes(file.type)) {
      return;
    }

    let reader = new FileReader();
    reader.onloadend = () => {
      let img = document.createElement('img')
      if (typeof reader.result === 'string') {
        img.src = reader.result;
        img.alt = file.name;
      }
      this.onLoad(img, file);
    };
    reader.readAsDataURL(file);
    this.uploadFile(file, (url) => this.onUpload(url), () => this.onError());
  }
}
